export default __webpack_public_path__ + "static/media/cs_icon_07_on.d57be823.png";